module.exports = __webpack_public_path__ + "templates.mobile-check-process-9afa9bd9.html";